import Vue from 'vue'

const LoadingServiceConstructor = Vue.extend(require('./index.vue').default)
let loadingInstance

const LoadingService = {
  show(params, isUploadAPI, theme) {
    if (!loadingInstance) {
      loadingInstance = new LoadingServiceConstructor({
        el: document.createElement('div')
      })
      document.body.appendChild(loadingInstance.$el)
    }
    loadingInstance.show(params, isUploadAPI, theme)
  },
  hide() {
    if (loadingInstance) {
      loadingInstance.hide()
    }
  }
}

export default LoadingService



// WEBPACK FOOTER //
// ./src/components/LoadingService/index.js